import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { ObservedValueOf } from 'rxjs/internal/types';
import { CustomerSignAgreementData } from '../../charter-payment/charter-payment.component';
import { CharterNote } from 'anchor-shared/lib/model/entity/charterNote';
import { map, take } from 'rxjs/operators';
import { CharterNoteDAO } from '../../../../../core/services/dao/charterNoteDAO';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { ContainsSubscriptions } from '../../../../../core/services/interfaces/contains-subscriptions';
import * as moment from 'moment';

@Component({
  selector: 'app-manage-charter-notes',
  templateUrl: './manage-charter-notes.component.html',
  styleUrls: ['./manage-charter-notes.component.scss'],
})
export class ManageCharterNotesComponent
  implements OnInit, ContainsSubscriptions, OnDestroy
{
  @Input()
  charterId: number;

  @Input()
  refresh: Subject<boolean>;

  newNote: string;
  addNoteLoading = false;
  subs: Subscription[] = [];

  templateData$: Observable<{
    notes: ObservedValueOf<Observable<CharterNote[]>>;
  }>;
  editingNote: boolean = false;
  noteBeingEdited: number = null;
  private originalNoteText: string = null;

  constructor(private readonly charterNoteDAO: CharterNoteDAO) {}

  ngOnInit(): void {
    this.initAsyncData();
    this.refreshNoteWatcher();
  }

  ngOnDestroy(): void {}

  saveCharterNote() {
    if (this.newNote) {
      this.addNoteLoading = true;
      this.charterNoteDAO
        .saveNote(this.charterId, this.newNote)
        .pipe(take(1))
        .subscribe(
          (data) => {
            this.addNoteLoading = false;
            this.newNote = '';
            this.initAsyncData();
          },
          (error) => (this.addNoteLoading = false),
        );
    }
  }

  private initAsyncData(): void {
    this.templateData$ = this.charterNoteDAO.getNotes(this.charterId).pipe(
      map((notes) => {
        return { notes };
      }),
    );
  }

  public formatDateTime(time: string): string {
    return moment(time).format('YYYY-MM-DD hh:mm a');
  }

  private refreshNoteWatcher(): void {
    if (this.refresh) {
      const sub = this.refresh.subscribe((doRefresh) => {
        if (doRefresh) {
          this.initAsyncData();
        }
      });
      this.subs.push(sub);
    }
  }

  editNote(id: number, note: string) {
    this.editingNote = true;
    this.noteBeingEdited = id;
    this.originalNoteText = note;
  }

  updateNote(id: number, note: CharterNote) {
    this.editingNote = false;
    this.noteBeingEdited = null;
    this.originalNoteText = null;

    this.charterNoteDAO.updateNote(id, note.note).pipe(take(1)).subscribe();
    // @ts-ignore
    note.updatedAt = moment().format();
  }

  cancelEdit(note: CharterNote) {
    this.editingNote = false;
    this.noteBeingEdited = null;

    note.note = this.originalNoteText;

    this.originalNoteText = null;
  }
}
